import * as React from 'react';
import styles from './RoleExplainer.module.css';

interface RoleExplainerProps {
  items: { label: string; description?: string }[];
}

const RoleExplainer: React.FC<RoleExplainerProps> = ({ items }) => (
  <div className={styles.RoleExplainer}>
    {items
      .filter((item) => item.description)
      .map((item) => (
        <div key={item.label} className={styles.Item}>
          <span className={styles.Label}>{item.label}: </span>
          {item.description}
        </div>
      ))}
  </div>
);

export default RoleExplainer;
